import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthState } from './auth-state';

// Must stay in sync with the write-capable role values in ./roles.ts's ROLES array.
const WRITE_ROLES = ['rw', 'admin', 'owner'];

@Injectable()
export class RoleService {

    constructor(private _store: Store) { }

    canWrite(orgKey: string): boolean {
        return WRITE_ROLES.includes(this._roleFor(orgKey));
    }

    isGuest(orgKey: string): boolean {
        return this._roleFor(orgKey) === 'guest';
    }

    private _roleFor(orgKey: string): string | undefined {
        const orgs = this._store.selectSnapshot(AuthState.availableOrgs) || [];
        return orgs.find(org => org.key === orgKey)?.access?.role;
    }
}
